var date = {};
module["exports"] = date;
date.month = require("./month");
date.weekday = require("./weekday");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/date/index.js
// module id = 2396
// module chunks = 2